(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDeleteController',VentahoyrealtimeDeleteController);

    VentahoyrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDeleteController($uibModalInstance, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventahoyrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
